import { kebabToCamelCase } from '../helpers/stringHelper';
import { wlPath } from '../helpers/whitelabel';

export const initialState = {
  fetched: false,
  data: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'CONTENT_PAGES_FETCHED':
      return Object.assign({}, state, {
        fetched: true,
        data: action.payload.map(item => {
          return {
            type: kebabToCamelCase(item.url_slug),
            title: item.page_heading,
            subtitle: item.card_general,
            image: `icons/${item.card_icon}`,
            gain: item.page_impact_amount,
            explanation: item.card_personal,
            onClickTransition: wlPath(`/action-plan/${item.url_slug}`),
            ...item,
          };
        }),
      });
    default:
      return state;
  }
}
